import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class InStorePickingService {

  constructor(
    private apiService: ApiService
  ) { }

  searchDeliveryImages(orderId: Number): Observable<any> {
    return this.apiService.get(`${this.apiService.deliveryImages}/${orderId}`);
  }
}
